import * as api from "./middleware/api.middleware";
import { requireActiveEnvironmentId } from "./environment.store";
import { getAuthHeader } from "./auth/authHeaders";

const serviceUrl = "audit_history";
const getAccessToken = () => getAuthHeader();

const getEnvironmentId = () => requireActiveEnvironmentId();

export function getAuditHistoryList() {
  const getResponse = api.get<any[]>(
    `environments/${getEnvironmentId()}/${serviceUrl}`,
    getAccessToken()
  );
  return getResponse;
}
